module.exports = __webpack_public_path__ + "img/interieur-lazy.c915abff.jpg";